export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6560.b8b302e5.jpg";